import dynamic from 'next/dynamic';
import ContentSlotBanner from 'app/components/CoverBanner/types/propTypes';

const CoverBanner = dynamic(() => import('app/components/CoverBanner/CoverBanner'), { ssr: false });

const RegistrationSelectAccountType = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationSelectAccountType'),
  { ssr: false },
);
const RegistrationSponsor = dynamic(() => import('@commerce-profile-webcomponents/ui/RegistrationSponsor'), {
  ssr: false,
});
const RegistrationUserDetails = dynamic(() => import('@commerce-profile-webcomponents/ui/RegistrationUserDetails'), {
  ssr: false,
});
const CoApplicantIdStepLatam = dynamic(() => import('@commerce-profile-webcomponents/ui/CoApplicantIdStepLatam'), {
  ssr: false,
});
const RegistrationInviteStep = dynamic(() => import('@commerce-profile-webcomponents/ui/RegistrationInviteStep'), {
  ssr: false,
});
const CoAppUserDetailsStep = dynamic(() => import('@commerce-profile-webcomponents/ui/CoAppUserDetailsStep'), {
  ssr: false,
});
const RegistrationPersonalPreviewStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationPersonalPreviewStep'),
  { ssr: false },
);
const RegistrationDownlineVerifyStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationDownlineVerifyStep'),
  { ssr: false },
);
const RegistrationIdVerificationStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationIdVerificationStep'),
  { ssr: false },
);
const RegistrationUsernameVerification = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationUsernameVerification'),
  { ssr: false },
);
const SinglePageRegistrationStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/SinglePageRegistrationStep'),
  { ssr: false },
);
const RegistrationUserDetailsStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationUserDetailsStep'),
  { ssr: false },
);
const RegistrationSelectAboKitStep = dynamic(
  () => import('@commerce-profile-webcomponents/ui/RegistrationSelectAboKitStep'),
  { ssr: false },
);

const mappings = {
  E2E: {
    [ContentSlotBanner.COVER_BANNER]: CoverBanner,
  },
  profile: {
    SelectAccountTypeStep: RegistrationSelectAccountType,
    UserDetailsStep: RegistrationUserDetails,
    ContactVerificationStep: RegistrationUsernameVerification,
    selectSponsorStep: RegistrationSponsor,
    SinglePageStep: SinglePageRegistrationStep,
    idStep: RegistrationIdVerificationStep,
    userDetailsStepLatam: RegistrationUserDetailsStep,
    kitStepLatam: RegistrationSelectAboKitStep,

    coApplicantIdStepLatam: CoApplicantIdStepLatam,
    inviteStep: RegistrationInviteStep,
    coAppUserDetailsStep: CoAppUserDetailsStep,

    userPreviewStep: RegistrationPersonalPreviewStep,
    userVerifyStepLatam: RegistrationDownlineVerifyStep,
  },
  checkout: {
    CheckoutPickupEtaBopis: () => <></>,
    CheckoutLineItemTh: () => <></>,
    CheckoutTaxes: () => <></>,
  },
};

export default mappings;
